import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">吃瓜热评</h2>
          <p className="section-subtitle">百万吃瓜群众都在讨论什么？来看看大家的精彩评论</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-start gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.user}
                  className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-background-200 flex-shrink-0 object-cover"
                  width="100"
                  height="100"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-foreground-900">{item.user}</span>
                    <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
                      item.tag === '热评' ? 'bg-primary-50 text-primary-600' :
                      item.tag === '热门' ? 'bg-accent-50 text-accent-600' :
                      item.tag === '深度' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-secondary-50 text-secondary-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes.toLocaleString()}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-share-forward-line"></i>
                  分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}